module.exports = [
  "backend.config",
  "DS",
  "apiCall",
  function(backend, DS, apiCall) {
    var news = DS.defineResource({
      name: "news",
      endpoint: "news",
      adapter: "cache",
      strategy: "single",
      idAttribute: "articleId",
      computed: {
        publishedDateRaw: [
          "publishStartDate",
          "createDate",
          function(published, created) {
            return published || created;
          }
        ],
        publishedDate: [
          "publishedDateRaw",
          function(published) {
            return moment(published).format("LL");
          }
        ]
      },
      beforeInject: function(config, attrs) {
        if (Array.isArray(attrs)) {
          var beforeInject = news.beforeInject.bind(this, config);
          attrs.forEach(beforeInject);
        } else {
          console.warn("article", attrs);
          // TODO remove
          // mangle properties for testing purposes
          // var imgs = [
          //   'https://images.pexels.com/photos/158063/bellingrath-gardens-alabama-landscape-scenic-158063.jpeg?w=940&h=650&dpr=2&auto=compress&cs=tinysrgb',
          //   'https://images.pexels.com/photos/132037/pexels-photo-132037.jpeg?h=350&dpr=2&auto=compress&cs=tinysrgb',
          //   'https://images.pexels.com/photos/39811/pexels-photo-39811.jpeg?w=940&h=650&dpr=2&auto=compress&cs=tinysrgb',
          //   'https://images.pexels.com/photos/248771/pexels-photo-248771.jpeg?w=940&h=650&dpr=2&auto=compress&cs=tinysrgb'
          // ];
          //
          // var phrases = [
          //   'This is a sentence for dummy text.',
          //   'Lorem ipsum dolor sit amet, that kind of thing.',
          //   'Another sentence here so as to make things longer than the others - et phone home.',
          //   '\n'
          // ];

          // attrs.comments = attrs.comments && attrs.comments.length ? attrs.comments : [
          //   comment('This is a comment. Some bla bla bla here. This may span several ' +
          //           'lines if the text is long. Some more bla bla bla here too.', 'Amy', [
          //     comment('This is a reply!', 'Bill'),
          //     comment('Another one!', 'Charly', [
          //       comment('And a reply to that reply!', 'Amy')
          //     ]),
          //     comment('Another one!', 'Bill'),
          //     comment('Another one!', 'Amy', [
          //       comment('And a reply to that reply!', 'Charly')
          //     ])
          //   ]),
          //   comment('Another top level comment. No replies.', 'Charly'),
          //   comment('Yet another comment. Some more bla bla.', 'Bill', [
          //     comment('Some reply...', 'Amy'),
          //     comment('Some other one...', 'Charly', [
          //       comment('With its own...', 'Bill')
          //     ]),
          //     comment('Replies, replies...', 'Bill')
          //   ])
          // ];

          // attrs.fullText = Array.from(Array(50)).map(x => phrases[Math.round(Math.random() * 1000) % phrases.length]).join(' ').replace(/( \n)+/g, '<br><br>');
          // attrs.likesEnabled = true; // TODO remove
          // attrs.category = 'GOODIES';
          // attrs.fullImgUrl = imgs[attrs.id % imgs.length];
          /**************************************************************/
          attrs.previewText =
            attrs.previewText || attrs.fullText.substr(0, 150) + "...";
          attrs.previewImgUrl = attrs.previewImgUrl || attrs.fullImgUrl;
        }
      }
    });

    // TODO remove
    // var idCount = 10;
    // function comment (txt, user, replies) {
    //   var pics = {
    //     'Amy': 'https://secure.gravatar.com/avatar/4ceb2b68d304b2e5cba74f2b2d60b5eb?s=100&d=retro&r=g',
    //     'Bill': 'https://secure.gravatar.com/avatar/36300265c3295c7dd05d1cb0b1aa38b4?s=100&d=retro&r=g',
    //     'Charly': 'https://secure.gravatar.com/avatar/df716c484d6c4e9fe038502057f76449?s=100&d=retro&r=g'
    //   };
    //   return {
    //     commentText: txt,
    //     userFullName: user,
    //     commenterAvatarUrl: pics[user],
    //     time: moment().subtract(1, 'week'),
    //     id: idCount++,
    //     replies
    //   };
    // }

    function getArticles() {
      // TODO remove
      // for (let i = 1; i <= 20; i++) {
      //   news.inject({ id: i + 30, headline: 'Mock One #' + i });
      // }

      return apiCall({
        endpoint: "news/$/@/"
      })
        .then(function(data) {
          data.forEach(item => news.inject(item));
          data.sort((a, b) => a.publishedDateRaw - b.publishedDateRaw);
          return data.slice(0, 25);
        })
        .catch(function(err) {
          console.error(err); // TODO
        });
    }

    function getArticle(id) {
      // Trigger view event
      apiCall({ endpoint: "news/event/view/$/@/" + id, method: "POST" });

      let article = news.get(id);
      if (article) {
        console.log("Found article in store", article);
        return Promise.resolve(article);
      }
      return apiCall({
        endpoint: "news/$/@/" + id
      }).catch(function(err) {
        console.error(err); // TODO
      });
    }

    function getRootArticle() {
      return apiCall({
        endpoint: "news/$/@/root"
      });
    }

    function addComment(comment) {
      return apiCall({
        endpoint: "news/$/@/" + comment.newsItemId + "/comment",
        method: "POST",
        data: comment
      }).then(function() {
        return apiCall({
          endpoint: "news/$/@/" + comment.newsItemId,
          resObj: news
        }).catch(function(err) {
          console.error(err); // TODO
        });
      });
    }

    function flagComment(comment) {
      console.warn("Will flag", { comment, articleId: comment.newsItemId });
      return apiCall({
        endpoint: "news/$/@/" + "commentInappropriate/" + comment.commentId,
        method: "POST"
      }).then(function() {
        return apiCall({
          endpoint: "news/$/@/" + comment.newsItemId,
          resObj: news
        }).catch(function(err) {
          console.error(err); // TODO
        });
      });
    }

    function toggleArticleLike(id, likeIt) {
      return apiCall({
        endpoint: "news/$/@/" + id + (likeIt ? "/like" : "/unlike"),
        method: "POST"
      }).then(function() {
        return apiCall({
          endpoint: "news/$/@/" + id,
          resObj: news
        }).catch(function(err) {
          console.error(err); // TODO
        });
      });
    }

    window.getArticles = getArticles;

    return {
      $resource: news,
      getArticles,
      getArticle,
      getRootArticle,
      toggleArticleLike,
      addComment,
      flagComment
    };
  }
];



// WEBPACK FOOTER //
// ./src/api/js-data/api/news.js